export const PROJECTS_URL = 'https://carellice.github.io/dueffe-home/';

export const redirectToProjects = (location = window.location) => {
    location.replace(PROJECTS_URL);
};
